import { AnyAction } from "redux";
import {
  REQUEST_SEARCH_ORDER,
  REQUEST_SEARCH_ORDER_ERROR,
  REQUEST_SEARCH_ORDER_SUCCESS,
} from "redux/actions/pages/statusOrder";

const defaultState = {
  data: {},
  error: null,
  loading: false,
};

export default (state = defaultState, action: AnyAction) => {
  switch (action.type) {
    case REQUEST_SEARCH_ORDER:
      return {
        ...state,
        loading: true,
      };
    case REQUEST_SEARCH_ORDER_SUCCESS:
      return {
        ...state,
        data: action.statusOrder,
        error: null,
        loading: false,
      };
    case REQUEST_SEARCH_ORDER_ERROR:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
};
